import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { GlobalService } from './../../../core/';
import { GlobalNamespace as _GlobalNS } from './../../../../environments/environment';
import { PropertyListItem } from "../../property";
import { FavoritePropertiesService } from '../../favorite-properties.service';
import { fcMilestoneHistoryService } from '../../fcMilestoneHistory.service';
import {OverlayPanelModule, OverlayPanel } from 'primeng/overlaypanel';
import { fcMilestoneHistory } from '../../fcMilestoneHistory';

@Component({
  selector: 'tpl-property-search-forclosure'
  , templateUrl: './search-forclosure.component.html'
  , styleUrls: [
    '../templates.scss',
    './search-forclosure.component.scss'
  ]
})
export class SearchForclosureComponent implements OnInit {
  @Input() routes : any = {};
  @Input() iconLeft: string;
  @Input() showPropertyIdLink: boolean;
  @Input() showOpenNewWindowIcon: boolean;
  @Input('value') property: PropertyListItem;
  @Input() showFCMilestoneHover: boolean;
  fcMilestoneChangeLog: fcMilestoneHistory[];
  loading: boolean;

  favoriteLoansUpdateData: any[];
  MyFavoritePropertiesCount = this._global.find((<any>_GlobalNS).paths.UserFavoritePropertiesCount);
  UserFavoritePropertiesMaxCount = this._global.find((<any>_GlobalNS).paths.UserFavoritePropertiesMaxCount);

  constructor(private render: Renderer2
    , private favoritePropertiesService: FavoritePropertiesService
    , private _global: GlobalService
    ,private FCMilestoechangeLogSvc: fcMilestoneHistoryService) { 

      favoritePropertiesService.getFavoritesCount().subscribe(count => {
        this.MyFavoritePropertiesCount = count;
      });
    }

  ngOnInit() {
    this.showPropertyIdLink = (this.showPropertyIdLink === undefined)?false:true;
    this.showOpenNewWindowIcon = (this.showOpenNewWindowIcon === undefined)?false:true;

    if(this.property === undefined || typeof this.property !== 'object'){
      console.log(new TypeError('@Input value is undefined'));   
    }
  }

  getFavIconClass(IsFavorite: number): any {
    if (IsFavorite === 1) {
      return 'fas fa-heart fav-heart-loan-selected';
    } else {
      return 'far fa-heart';
    }
  }

  // Logic for list price hover and setting the ListPriceChangeLog object
  fcMilestoneHover(event, overlayPanel: OverlayPanel, objectId: Number) {
    this.loading = true;
    this.FCMilestoechangeLogSvc.find(objectId)
      .subscribe((fcMilestoneData: fcMilestoneHistory[]) => {
        this.fcMilestoneChangeLog = (<any>fcMilestoneData).data;
        overlayPanel.toggle(event);
        this.loading = false;
      });
  }

  updateFavorite(el: any, propertyId: number): void {
    let proceedToUpdate = false;
    const favIconId = el.getAttribute('data-fav-loan-icon-id');
    const isFavFlag = el.getAttribute('data-fav-loan-flag');
    if (isFavFlag === '1') {
      // -- Remove from favs
      this.render.removeAttribute(el, 'class');
      this.render.addClass(el, 'far');
      this.render.addClass(el, 'fa-heart');
      el.setAttribute('data-fav-loan-flag', '0');
      proceedToUpdate = true;
    } else {
      // -- Add to favs
      if (this.MyFavoritePropertiesCount < this.UserFavoritePropertiesMaxCount) {
        this.render.addClass(el, 'fas');
        this.render.addClass(el, 'fa-heart');
        this.render.addClass(el, 'fav-heart-loan-selected');
        el.setAttribute('data-fav-loan-flag', '1');
        proceedToUpdate = true;
      } else {
        this.favoritePropertiesService.setDisplayMaxFavCountErrorMessageDialog(true);
      }
    }

    if (proceedToUpdate) {
      this.favoritePropertiesService.updateFavorites(propertyId, el.getAttribute('data-fav-loan-flag'))
        .subscribe((res) => {
          this.favoriteLoansUpdateData = (<any>res).data;
          this.favoritePropertiesService.setFavoritesCount(this.favoriteLoansUpdateData[0].CurrentCount);
          this.favoritePropertiesService.setReloadFavoritePropertiesBar(true);
        }, (error) => {
          console.log('Couldnot update favorites');
      });
    }
  }

}
